import type z from "zod";

import { optionSchema } from "@/schemas/option";
import { credentialStatusIdSchema } from "@/types/credentialStatus";

export const CredentialStatusOptionSchema = optionSchema(
  credentialStatusIdSchema,
);
export type CredentialStatusOption = z.infer<
  typeof CredentialStatusOptionSchema
>;
